import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';
import Companies from './companies';

describe('Companies', () => {
  test('renders Companies component', () => {
    const companies = '[{"id": "1", "gcs_company_code": "GCS",'
                         + ' "company_name": "グッドな薬局渋谷店",'
                         + ' "issue_ticket_count": "100", "enable_ticket_count": "90",'
                         + ' "consumed_ticket_count": "10", "expired_ticket_count": "0",'
                         + ' "total_purchased_price": "1000"}]'
    render(<Companies m_companies={companies} />);

    // screen.debug();
  
    expect(screen.getByText('グッドな薬局渋谷店')).toBeInTheDocument();
    expect(screen.getByText('チケットデータ一覧')).toBeInTheDocument();
  });
});
